import { useEffect, useEffectEvent } from "react";

import { useAuth } from "./use-auth";

/**
 * Reauthenticates the user behind the scenes when their token is expiring soon.
 *
 * Called once near the top of the authenticated component tree (e.g. App).
 * Each page navigation re-evaluates the token — if it's within 2 hours of
 * expiry and not yet expired, we silently extend the session.
 *
 * If the token fully expires (e.g. user was inactive), the Apollo ErrorLink
 * in providers.jsx handles the UX: clear localStorage → hard reload → login.
 */
export function useAuthExpiry() {
  const {
    isTokenExpired,
    isTokenExpiringSoon,
    reauthenticateActiveUser,
  } = useAuth();

  const onTokenExpiringSoon = useEffectEvent(() => {
    reauthenticateActiveUser();
  });

  useEffect(() => {
    if (!isTokenExpired && isTokenExpiringSoon) {
      onTokenExpiringSoon();
    }
  }, [isTokenExpired, isTokenExpiringSoon]);
}
